import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=64857972&scoped=true"
import script from "./gift.vue?vue&type=script&lang=js"
export * from "./gift.vue?vue&type=script&lang=js"
import style0 from "./gift.vue?vue&type=style&index=0&id=64857972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64857972",
  null
  
)

export default component.exports